const STORAGE_KEY = 'jm_tracking'

const TRACKING_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
] as const

const captureTrackingParams = (url: URL) => {
  const params: Record<string, string> = {}
  for (const key of TRACKING_PARAMS) {
    const value = url.searchParams.get(key)
    if (value) {
      params[key] = value
    }
  }

  if (Object.keys(params).length === 0) return

  const existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...existing, ...params }))
}

const captureSessionContext = () => {
  const existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}')
  if (existing.landing_page) return

  const context: Record<string, string> = {
    landing_page: window.location.pathname + window.location.search,
  }
  if (document.referrer) {
    context.referrer = document.referrer
  }

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...existing, ...context }))
}

export default defineNuxtPlugin(() => {
  captureSessionContext()
  captureTrackingParams(new URL(window.location.href))

  const router = useRouter()
  router.afterEach((to) => {
    const url = new URL(to.fullPath, window.location.origin)
    captureTrackingParams(url)
  })
})
